export default "__VITE_ASSET__Cpo70rAh__"